import { LoaderHandler } from 'planning-portal-library/src/lib/core/domain/models/loader-enabler';
import { FiltersScheduler } from 'planning-portal-library/src/lib/core/domain/models/scheduler/filters-scheduler';
import { PlanScheduled } from 'planning-portal-library/src/lib/core/domain/models/scheduler/plan-scheduled';
import { PlanScheduledRequest } from 'planning-portal-library/src/lib/core/domain/requests/plans/get-scheduled-plans-request';

export class EnableLoading {
  static readonly type = '[Scheduler] Enable Loading';
  constructor(public payload: LoaderHandler | undefined) {}
}

export class DisableLoading {
  static readonly type = '[Scheduler] Disable Loading';
  constructor(public payload: LoaderHandler | undefined) {}
}

export class SetPlansScheduled {
    static readonly type = '[Scheduler] Set plans scheduled';
    constructor(public payload: PlanScheduled[] | undefined) {}
}

export class SetCurrentPage {
    static readonly type = '[Scheduler] Set current page';
    constructor(public payload: number | undefined) {}
}

export class SetFilters {
  static readonly type = '[Scheduler] Set filters';
  constructor(public payload: FiltersScheduler | undefined) {}
}

